import { render } from "./EmailRules.vue?vue&type=template&id=71409046"
import script from "./EmailRules.vue?vue&type=script&lang=js"
export * from "./EmailRules.vue?vue&type=script&lang=js"

import exportComponent from "/app/tmp/aft/V3/v2026.4.r0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__